module.exports = __webpack_public_path__ + "static/media/logoNew.24d36667.svg";